import {Component, ElementRef, Injector, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'app-form-autocomplete',
  templateUrl: './form-autocomplete.component.html'
})

export class FormAutocompleteComponent implements OnInit {
  config;
  grupo: FormGroup;
  filteredOptions: Observable<any[]>;
  @ViewChild('input') input: ElementRef;
  @ViewChild('auto') auto: ElementRef;
  selected;
  private service;
  serviceInject;
  filteredLength;
  max = 20;
  isOpened;

  constructor(private injector: Injector) {
  }

  importService() {
    if (this.config.optionsFrom) {
      const service = this.config.optionsFrom.charAt(0).toUpperCase() + this.config.optionsFrom.slice(1) + 'Service';
      import
      ('../../../core/services/' + this.config.optionsFrom + '.service').then(module => {
        this.service = module[service];
        this.getService();
        this.serviceInject['get' + this.config.optionsFrom.charAt(0).toUpperCase() + this.config.optionsFrom.slice(1) + 'Storage']().subscribe(data => {
          if (data) {
            this.config.options = data;
          } else {
            this.serviceInject['get' + this.config.optionsFrom.charAt(0).toUpperCase() + this.config.optionsFrom.slice(1)]().subscribe(options => {
              this.config.options = options;
            });
          }
          this.initFiltered();
          if (this.grupo.controls[this.config.nome].valueChanges) {
            if (this.grupo.controls[this.config.nome]['value']) {
              this.checkValidValue(this.grupo.controls[this.config.nome]['value']);
            }
          }
        });
      });
    }
  }

  getService() {
    if (typeof this.serviceInject === 'undefined') {
      this.serviceInject = this.injector.get(this.service);
    }
    return this.serviceInject;
  }

  filterOptions(name: string) {
    const filtered = this.config.options.filter(option =>
      option.toLowerCase().indexOf(name.toLowerCase()) === 0);
    this.filteredLength = filtered.length;
    return filtered;
  }

  filterAnyPosition(value) {
    const filterValue = value.toLowerCase();
    const filtered = this.config.options.filter(option => option.toLowerCase().includes(filterValue));
    this.filteredLength = filtered.length;
    return filtered;
  }

  optionSelected(event) {
    this.selected = event.option.value;
  }

  clearInput() {
    if (this.selected !== this.input.nativeElement.value) {
      this.input.nativeElement.value = null;
      this.grupo.controls[this.config.nome].setValue(null);
    }
    const component = this;
    setTimeout(function () {
      component.isOpened = false;
    }, 300);
  }

  initFiltered() {
    if (this.config.options && this.config.options.length) {
      this.filteredLength = this.config.options.length;
      this.filteredOptions = this.grupo.controls[this.config.nome].valueChanges
        .pipe(
          startWith(''),
          map(option => option ? this.getFilter(option) : this.config.options.slice()
          ));
    }
  }

  getFilter(option) {
    this.max = 20;
    switch (this.config.filterType) {
      case undefined: {
        return this.filterOptions(option);
      }
      case 'anyPosition': {
        return this.filterAnyPosition(option);
      }
    }
  }

  showMore() {
    if (this.filteredLength - 20 >= this.max) {
      return this.max = this.max + 20;
    } else {
      return this.max = this.filteredLength;
    }
  }

  checkValidValue(value) {
    if (this.config.options && this.config.options.indexOf(value) === -1) {
      this.input.nativeElement.value = null;
      this.grupo.controls[this.config.nome].setValue(null);
    }
  }

  ngOnInit() {
    this.importService();
    this.initFiltered();
    if (this.grupo.controls[this.config.nome].valueChanges) {
      if (this.config.options && this.grupo.controls[this.config.nome]['value']) {
        this.checkValidValue(this.grupo.controls[this.config.nome]['value']);
      }
    }
  }
}
